module.exports = __webpack_public_path__ + "static/img/c-b2.623b0828.png";